import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { BrowserRouter } from "react-router-dom";
import { DrawerProvider } from "./extras/providers/DrawerProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <DrawerProvider>
        <App />
      </DrawerProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
